import Qs from "qs";

import { parseUrlArray } from "@edgetier/utilities";

export const getInitialValues = ({ interactionType, modelId }: Qs.ParsedQs) => {
    return {
        interactionType: parseUrlArray(interactionType),
        modelId: parseUrlArray(modelId),
    };
};
